import type { AuthWebClient, AuthRequestInit } from "@no-busy-work/auth/web";
import type { PublicAuthSession } from "@no-busy-work/auth/protocol";
import { apiPath } from "./apiBase";

export interface JsonRequestOptions extends Omit<AuthRequestInit, "session"> {
  readonly session?: PublicAuthSession | null;
}

export async function requestJson<TResponse>(
  authClient: AuthWebClient,
  path: string,
  options: JsonRequestOptions = {}
): Promise<TResponse> {
  const response = await authClient.authFetch(
    apiPath(path),
    {
      method: options.method ?? "GET",
      ...(options.body === undefined ? {} : { body: options.body }),
      ...(options.csrfToken === undefined ? {} : { csrfToken: options.csrfToken }),
      ...(options.headers === undefined ? {} : { headers: options.headers })
    },
    authSession(options.session)
  );
  const payload = await response.json().catch(() => null);
  if (!response.ok || payload?.ok === false) {
    throw new Error(payload?.code ?? `http_${response.status}`);
  }
  return payload as TResponse;
}

export function authSession(session: PublicAuthSession | null | undefined): { readonly csrfToken?: string } | undefined {
  return session?.authenticated ? { csrfToken: session.csrfToken } : undefined;
}
